import React from "react";

const SectionTitle = ({
  title,
  paragraph,
  width = "570px",
  center,
  mb = "100px",
}: {
  title: React.ReactNode;
  paragraph: React.ReactNode;
  width?: string;
  center?: boolean;
  mb?: string;
}) => {
  const titleIsHeading =
    React.isValidElement(title) &&
    typeof title.type === "string" &&
    /^h[1-6]$/.test(title.type);

  return (
    <>
      <div
        className={`wow fadeInUp w-full ${center ? "mx-auto text-center" : ""}`}
        data-wow-delay=".1s"
        style={{ maxWidth: width, marginBottom: mb }}
      >
        {titleIsHeading ? (
          title
        ) : (
          <h2 className="mb-4 text-3xl font-bold !leading-tight text-black dark:text-white sm:text-4xl md:text-[45px]">
            {title}
          </h2>
        )}
        <div className="text-base !leading-relaxed text-body-color md:text-lg">
          {paragraph}
        </div>
      </div>
    </>
  );
};

export default SectionTitle;
